// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__31-FB","title":"Navbar_title__2CGsW"};